module.exports = "/assets/data/b0a1307357c46a2a051da063fe3a6173-EX2.data.json";